import api from 'Application/api/api';

const getTemplateState = signal =>
	api.get('/template-state', {
		signal,
	});

export default getTemplateState;
